<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div
          class="col-xl-2 col-lg-3 col-md-4 col-sm-6"
          v-for="(t, index) in tableList"
          :key="index"
        >
          <a class="table-booking">
            <div class="table-booking-container">
              <div class="table-booking-header">
                <div class="d-flex align-items-center ts-justify-between">
                  <div class="flex-1">
                    <div class="title">TABLE</div>
                    <div class="no">{{ t.table_no }}</div>
                    <div class="desc">max {{ t.max_num_person }}</div>
                  </div>
                  <div class="pr-1 text-success"></div>
                </div>
              </div>
              <div class="table-booking-body">
                <div class="booking" v-for="(s, index) in schedules" :key="index"
                  @dblclick.prevent="bookingTable(t, s)"
                >
                  <div class="time">{{ s.schedule_time }}</div>
                  <div class="info">
                    {{
                    getDescription({
                      table_id: t.table_id,
                      schedule_id: s.schedule_id
                    })
                    }}
                  </div>
                  <div
                    class="status upcoming"
                    v-if="getDescription({
											table_id: t.table_id,
											schedule_id: s.schedule_id 
										})"
                  >
                    <a-popconfirm
                      placement="leftTop"
                      :title="$t('are_you_sure_to_delete')"
                      :ok-text="$t('yes')"
                      :cancel-text="$t('no')"
                      @confirm="cancelBooking({ 
												table_id: t.table_id,
												schedule_id: s.schedule_id
											}, index)"
                    >
                      <a href="#" :disabled="schedule_index == index">
                        <i class="fas fa-circle-notch spin ts-text-yellow-500 fa-2x" v-if="schedule_index == index"></i>
                        <i class="fa fa-times fa-2x ts-text-yellow-500" v-else></i>
                      </a>
                    </a-popconfirm>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </ts-loading-banner>
    <a-modal
      v-if="visible"
      v-model="visible"
      :footer="null"
      :centered="true"
      :zIndex="1020"
      width="500px"
    >
      <template v-slot:title>
        <div class="d-flex align-items-center mb-3">
          <h4 class="modal-title d-flex align-items-center">
            <img src="@/assets/icon-table-black.svg" class="mr-2 ts-h-8" />
            {{ selectedTable.table_no }}
            <small
              class="f-s-13 f-w-600 ml-2"
            >max {{ selectedTable.max_num_person }}</small>
          </h4>
        </div>
      </template>
      <BookingForm 
        :table="selectedTable" 
        @cancel="onCancel" 
        @loading="(value) => loading = value" 
      />
    </a-modal>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import BookingForm from './booking-form'
export default {
  components: {
    BookingForm
  },
  data() {
    return {
      loading: false,
      visible: false,
      selectedTable: {},
			schedule_index: null,
      model: {
        table_id: null,
        booking_lists: []
      }
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    if (window.innerWidth >= 1300) {
      this.width_modal = '40%'
      return
    }
    if (window.innerWidth >= 1000) {
      this.width_modal = '70%'
      return
    }
    if (window.innerWidth >= 500) {
      this.width_modal = '100%'
      return
    }
  },
  computed: {
    ...mapGetters('booking/tableBooking', ['getDescription', 'getBookingId']),
    ...mapState('booking/tableBooking', ['tableList', 'schedules'])
  },
  methods: {
    ...mapActions('booking/tableBooking', ['getTable', 'getSchedule', 'fetch', 'destroy', 'getCustomer']),
    async fetchData() {
      this.loading = true
      await this.getTable()
      await this.getSchedule()
      await this.getCustomer()
      await this.fetch().finally(() => (this.loading = false))
    },
    bookingTable(table, schedule) {
      this.visible = true
      this.selectedTable = Object.assign({}, table, schedule)
    },
    onCancel() {
      this.visible = false
		},
		cancelBooking(schedule, index){
			this.schedule_index = index
			let id = this.getBookingId(schedule)
			this.destroy(id)
				.then(response => {
					this.loading = true
					this.fetch().finally(() => this.loading = false )
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.schedule_index = null
				})
		}
  }
}
</script>